import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CertificadosLayout from "../components/CertificadosLayout";

const CertificadosPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Certificados" />
        <CertificadosLayout />
      </MasterLayout>
    </>
  );
};

export default CertificadosPage;
